import React from 'react';
import { BRANDS } from './data';

export const TrustRow = () => (
  <section className="border-y border-border bg-muted/50">
    <div className="mx-auto max-w-7xl px-6 py-10 md:px-12">
      <p className="mb-6 text-center text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
        Add a gift card from any store you love — always optional
      </p>
      <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
        {BRANDS.map((b) => (
          <span key={b} className="text-xl font-bold tracking-tight text-foreground/40 transition-colors hover:text-foreground/70 md:text-2xl">
            {b}
          </span>
        ))}
        <span className="rounded-full bg-card px-4 py-1.5 text-sm font-semibold text-primary shadow-sm">+10,000 more</span>
      </div>
    </div>
  </section>
);
